import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haRoleListPipe'
})
export class HaRoleListPipePipe implements PipeTransform {

  transform(roleData: any[],  searchTerm: string): any[] {
    if (!roleData || !searchTerm) { return roleData; }
    return roleData.filter(ad =>
     
    
      ad.roleName.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1
     
    



    );
  }

}
